import { isCypressEnvironment, isFatEnvironment, isLocalEnvironment } from '@shared/environment';

export function shouldTrackEventHistory(): boolean {
    if (isCypressEnvironment()) {
        return false;
    }

    return isLocalEnvironment() || isFatEnvironment();
}
